import SVG from 'react-inlinesvg'

const BASE_PATH = '../../assets/icons'

const IconsLibrary = {
  alcohols: '/icons/wine.svg',
  close: '/icons/close.svg',
  kidsMenu: '/icons/baloon.svg',
  burger: '/icons/burger.svg',
  additions: '/icons/fries.svg',
  croissant: '/icons/croissant.svg',
  deserts: '/icons/desserts.svg',
  drumstick: '/icons/drumstick.svg',
  startes: '/icons/fries.svg',
  grain: '/icons/grain.svg',
  pizza: '/icons/pizza.svg',
  salads: '/icons/salad.svg',
  soups: '/icons/soup.svg',
  starters: '/icons/starter.svg',
  mainDishes: '/icons/steak.svg',
  sushi: '/icons/sushi.svg',
  menu: '/icons/toque.svg',
  trash: '/icons/trash.svg',
  edit: '/icons/edit.svg',
  tick: '/icons/tick.svg',
  info: '/icons/info.svg',
  plus: '/icons/plus.svg',
  minus: '/icons/minus.svg',
  coldDrinks: '/icons/ice-water.svg',
  hotDrinks: '/icons/tea.svg'
}

const Icon = props => {
  const { name } = props
  try {
    return <SVG src={IconsLibrary[name]} preProcessor={code => code.replace(/fill=".*?"/g, '')}></SVG>
  } catch (error) {
    console.error(`<Icon> Missing "${name}" icon`, error)
    return <div></div>
  }
}

export default Icon
